module.exports = __webpack_public_path__ + "c75e564d5b3453b0b2331877c852ff8b.MP3";